export default async function createRule({ commit, rootGetters, dispatch }, ruleData) {
    try {
        commit('SET_CREATE_RULE_LOADING', true);

        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];

        let customer_id = customer.customer_id;
        if (customer_id === 0) {
            customer_id = selected_customer.customer_id;
        }

        const data = {
            ...ruleData,
            customer_id
        };

        const response = await window.axios.post('/proxy/ai/classification-rules', data);

        if (response.data.success) {
            dispatch('notifications/pushNotification', 'Classification rule created successfully', { root: true });
            return response.data.data;
        } else {
            dispatch('notifications/setError', 'Failed to create classification rule', { root: true });
        }
    } catch (error) {
        console.error('Error creating classification rule:', error);
        dispatch('notifications/setError', 'Failed to create classification rule', { root: true });
    } finally {
        commit('SET_CREATE_RULE_LOADING', false);
    }
}